const EmergencyLightIcon = ({ strokeColor = "#808080" }) => {
  return (
    <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 795.1 795.1">
      <g id="Circles">
        <circle id="Grey_Bkg" data-name="Grey Bkg" fill="#4d4d4d" cx="397.55" cy="397.55" r="388.66"/>
        <circle 
          id="Grey" 
          fill="none" 
          stroke={strokeColor} 
          strokeWidth="50px" 
          strokeMiterlimit="10" 
          cx="397.55" 
          cy="397.55" 
          r="372.55"
        />
        <circle 
          id="White_Inner" 
          data-name="White Inner" 
          fill="none" 
          stroke="#fff" 
          strokeWidth="20px" 
          strokeMiterlimit="10" 
          cx="397.55" 
          cy="397.55" 
          r="343.4"
        />
      </g>
      <g id="Shapes">
        <g id="Layer_1-2" data-name="Layer 1-2">
          <path 
            fill="#fcfcfc" 
            d="M552.6,401.58c-31.55.01-62.38-.19-93.21.06-67.87.54-135.74,1.27-203.61,2.02-10.52.12-21.24.57-27.93-9.45-2.8-4.19-5.4-9.5-5.51-14.36-.88-39.12-.95-78.25-1.66-117.37-.47-25.8,8.56-46.63,30.06-61.6,13.26-9.23,28.63-8.58,43.54-8.91,29.93-.65,59.88-.38,89.83-.57,39.72-.26,79.45-.41,119.16-.99,35.86-.52,61.39,17.57,69.77,50.3.94,3.67,1.36,7.57,1.36,11.36.06,42.1.03,84.2-.07,126.3-.02,9.73-8.79,19.21-21.73,23.21M267.42,372.84h276.01c0-39.64.16-77.87-.18-116.09-.05-5.7-1.41-11.94-4.03-16.95-7.35-14.09-20.48-17.01-35.25-16.93-72.65.39-145.3.5-217.95.7-18.79.05-33.45,14.38-33.38,33.16.11,32.31.55,64.62.73,96.94.03,6.07-.5,12.14-.81,19.19,4.97,0,9.07,0,14.86,0Z"
          />
          <path 
            fill="#fcfcfc" 
            d="M516.64,482.33c12.93,25.85,25.4,51.19,38.02,76.45,3.64,7.29,2.59,13.84-2.77,19.5-4.91,5.19-11.05,6.86-17.58,3.05-2.38-1.38-4.85-3.49-6.05-5.88-18.11-36.03-36.04-72.15-53.95-108.29-3.48-7.03-6.21-14.14-.35-21.49,6.27-7.85,16.09-8.73,22.89-1.24,3.28,3.62,5.72,8.14,7.93,12.56,4.06,8.14,7.67,16.5,11.86,25.32h0Z"
          />
          <path 
            fill="#fcfcfc" 
            d="M292.6,436.56c6.15-5.93,12.49-6.5,18.96-2.35,6.99,4.48,8.5,11.37,5.88,18.7-14.69,41.07-29.53,82.09-44.56,123.03-2.93,7.97-10.11,8.32-17.11,7.17-6.79-1.12-12.66-8.85-11.21-15.72,1.68-7.97,4.48-15.75,7.28-23.43,11.95-32.76,24.07-65.46,36.2-98.15,1.12-3.01,2.72-5.84,4.57-9.25h0Z"
          />
          <path 
            fill="#fefefe" 
            d="M414.15,510.14c0,30.5.02,60.11,0,89.72-.01,12.11-5.88,18.97-15.98,18.84-9.66-.13-16.02-7.64-16.03-19.29-.05-37.9-.04-75.8,0-113.7,0-9.14,6.92-16.32,15.7-16.51,8.73-.18,16.06,6.94,16.26,16.07.17,7.99.06,15.99.07,24.87h0Z"
          />
        </g>
      </g>
    </svg>
  );
};

export default EmergencyLightIcon;